// Tutorial progress localStorage schema following typescript-strict skill patterns

export type SectionProgress = {
  completed: boolean;
  completedAt?: string; // ISO timestamp
};

export type TutorialProgressEntry = {
  lastSection: string; // Section ID
  lastVisited: string; // ISO timestamp
  sections: Record<string, SectionProgress>;
  startedAt: string; // ISO timestamp
  version: number; // Tutorial content version at time of save
};

export type TutorialProgressStore = {
  tutorials: Record<string, TutorialProgressEntry>;
};

// Storage key
export const STORAGE_KEY = "bntvllnt:tutorials";

// Schema validation type guard (follows typescript-strict pattern)
export function isValidProgressStore(
  data: unknown,
): data is TutorialProgressStore {
  if (!data || typeof data !== "object") return false;
  const object = data as Record<string, unknown>;

  // Check tutorials object exists
  if (!object.tutorials || typeof object.tutorials !== "object") return false;

  return true;
}
